










import Vue from 'vue';
import AdminLayout from '@/components/Admin/AdminLayout.vue';

export default Vue.extend({
  name: 'Models',
  components: {
    AdminLayout
  },
  computed: {
    listingsComponents(): Array<any> {
      return [
        {
          component: () =>
            import('@/components/Admin/Models/HeaderComponent.vue')
        },
        {
          component: () =>
            import('@/components/Admin/Models/Filter/AdvancedFilter.vue')
        },
        {
          component: () =>
            import('@/components/Admin/Models/Table/ScenariosTable.vue')
        }
      ];
    },
    getScenariosIsLoading(): boolean {
      return this.$store.direct.state.Model.getScenariosIsLoading;
    },
    scenariosFilter(): boolean {
      return this.$store.direct.state.Model.scenariosFilter;
    }
  },
  watch: {
    scenariosFilter: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value) {
          this.getScenarios();
        }
      }
    }
  },
  mounted() {
    // Update "fromAddNewRegion"
    this.$store.direct.commit.Model.UPDATE_FROM_ADD_NEW_REGION(true);
    // Reset parent scenario used greenfield
    this.$store.direct.commit.Model.UPDATE_PARENT_SCENARIO_FOR_GREENFIELD(null);
  },
  methods: {
    getScenarios() {
      this.$store.direct.dispatch.Model.getScenarios().catch((error: any) => {
        console.log('Error getting scenarios data', error);
      });
    }
  }
});
